// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAutoFundingConfigRenewalDto
 */
export interface IAutoFundingConfigRenewalDto {
    /**
     * 
     * @type {number}
     * @memberof IAutoFundingConfigRenewalDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAutoFundingConfigRenewalDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IAutoFundingConfigRenewalDto
     */
    auto_enrollment_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoFundingConfigRenewalDto
     */
    per_person_spend_limit_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoFundingConfigRenewalDto
     */
    min_election_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoFundingConfigRenewalDto
     */
    max_election_amount?: number;
}

/**
 * Check if a given object implements the IAutoFundingConfigRenewalDto interface.
 */
export function instanceOfIAutoFundingConfigRenewalDto(value: object): value is IAutoFundingConfigRenewalDto {
    return true;
}

export function IAutoFundingConfigRenewalDtoFromJSON(json: any): IAutoFundingConfigRenewalDto {
    return IAutoFundingConfigRenewalDtoFromJSONTyped(json, false);
}

export function IAutoFundingConfigRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAutoFundingConfigRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'auto_enrollment_amount': json['auto_enrollment_amount'] == null ? undefined : json['auto_enrollment_amount'],
        'per_person_spend_limit_amount': json['per_person_spend_limit_amount'] == null ? undefined : json['per_person_spend_limit_amount'],
        'min_election_amount': json['min_election_amount'] == null ? undefined : json['min_election_amount'],
        'max_election_amount': json['max_election_amount'] == null ? undefined : json['max_election_amount'],
    };
}

export function IAutoFundingConfigRenewalDtoToJSON(json: any): IAutoFundingConfigRenewalDto {
    return IAutoFundingConfigRenewalDtoToJSONTyped(json, false);
}

export function IAutoFundingConfigRenewalDtoToJSONTyped(value?: IAutoFundingConfigRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'auto_enrollment_amount': value['auto_enrollment_amount'],
        'per_person_spend_limit_amount': value['per_person_spend_limit_amount'],
        'min_election_amount': value['min_election_amount'],
        'max_election_amount': value['max_election_amount'],
    };
}

